<template>
  <ThankYouPageBLG />
</template>

<script>
import ThankYouPageBLG from "./ThankYouPageBLG.vue";

export default {
  components: {
    ThankYouPageBLG,
  },
};
</script>
